import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-700 pt-16 pb-8 px-6" data-id="element-103">
      <div className="max-w-7xl mx-auto" data-id="element-104">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-16" data-id="element-105">
          <div className="col-span-2" data-id="element-106">
            <div className="flex items-center gap-2 mb-6" data-id="element-107">
              <div className="w-3 h-3 bg-accent-teal rounded-sm" data-id="element-108"></div>
              <span className="font-mono font-bold text-xl text-white tracking-wider" data-id="element-109">
                ROGUEHAVEN
              </span>
            </div>
            <p className="text-sm text-gray-400 mb-6 max-w-xs" data-id="element-110">
              The command center for data-driven PPC agencies. Unify, analyze,
              and report with absolute precision.
            </p>
            <div className="text-sm text-gray-500 font-mono" data-id="element-111">
              <p data-id="element-112">Limassol, Cyprus</p>
              <p className="mt-1 hover:text-accent-teal transition-colors cursor-pointer" data-id="element-113">
                hello@roguehaven.io
              </p>
            </div>
          </div>

          <div data-id="element-114">
            <h4 className="text-white font-semibold mb-4" data-id="element-115">Platform</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-116">
              <li data-id="element-117">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-118">
                  Nexus Sync
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-120">
                  Pulse Monitor
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-122">
                  Verdikt Reports
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-124">
                  Cipher Attribution
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-125">
            <h4 className="text-white font-semibold mb-4" data-id="element-126">Company</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-127">
              <li data-id="element-128">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-129">
                  About Us
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-131">
                  Careers
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-133">
                  Partners
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-135">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-136">
            <h4 className="text-white font-semibold mb-4" data-id="element-137">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-138">
              <li data-id="element-139">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-140">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-141">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-142">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-143">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-144">
                  Data Processing
                </a>
              </li>
              <li data-id="element-145">
                <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-146">
                  Security
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-navy-700/50 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-147">
          <p className="text-xs text-gray-500 font-mono" data-id="element-148">
            © 2026 Roguehaven. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-gray-500 font-mono" data-id="element-149">
            <span className="w-2 h-2 rounded-full bg-accent-teal animate-pulse" data-id="element-150"></span>
            All systems operational
          </div>
        </div>
      </div>
    </footer>;
}